import { createContext } from "react";

interface RegisterPageContextData {
    setCurrentPage: (page: string) => void,
    handleScroll: () => void,
}

export const RegisterPageContext = createContext<RegisterPageContextData>({} as RegisterPageContextData)